<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-box">
      <div class="modal-icon-wrap" v-if="type === 'success'">
        <div class="modal-icon-ring"></div>
        <div  class="modal-icon-circle">
          <svg data-v-62a78c4c="" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline data-v-62a78c4c="" points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
      </div>

      <h3 class="modal-title">
        {{ type === 'success' ? 'Success' : 'Error' }}
      </h3>

      <p class="modal-message">{{ message }}</p>

      <button class="btn modal-btn btn-primary btn-lg" @click="handleConfirm">
        OK
      </button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  show: Boolean,
  type: String,
  message: String,
  onConfirm: Function
})

const emit = defineEmits(['close'])

const handleConfirm = () => {
  props.onConfirm && props.onConfirm()
  emit('close')
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-box {
  background: white;
  padding: 24px;
  border-radius: 12px;
  width: 500px;
  text-align: center;
}

.modal-title {
  font-size: 2rem;
  margin-bottom: 10px;
}

.modal-message {
  font-size: 1.25rem;
  margin-bottom: 40px;
}

.modal-btn {
  width: 150px;
  cursor: pointer;
  margin-bottom: 4rem;
}
.modal-icon-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
  margin-top: 4rem;
}
.modal-icon-ring{
    position: absolute;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: rgba(39, 174, 96, 0.1);
    animation: ring-pulse 2s ease-in-out infinite;
}
.modal-icon-circle {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: linear-gradient(135deg, #27ae60, #2ecc71);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    box-shadow: 0 6px 20px rgba(39, 174, 96, 0.35);
    position: relative;
    z-index: 1;
}

@keyframes ring-pulse {
  0%, 100% {
      transform: scale(1);
      opacity: 0.6;
  }
  50% {
      transform: scale(1.5);
      opacity: 0.25;
  }
}

</style>